import * as actionTypes from './actionTypes';


export const addEsirFormDetails = (payload) => {
    return {
      type: actionTypes.ADD_ESIR_PROPOSAL_FORM,
      payload: payload,
    };
  };